import { EmbeddingContext } from '../../pages/WindmillAppPage/types';

interface MessageLike {
  id?: number | string;
  composite_id?: string | null;
}

interface CaseLike {
  id?: number | null;
}

/**
 * Placement context for a message card.
 *
 * Case feeds carry the Postgres message id in `id`; search results carry the
 * composite id there instead and have no Postgres id at all. A numeric id is
 * sent alone — the backend derives the composite id from it — and the
 * composite id is sent only when there is nothing better.
 */
export function messageEmbeddingContext(
  message: MessageLike,
  narrative?: CaseLike | null,
): EmbeddingContext {
  const context: EmbeddingContext = { mode: 'message' };
  if (narrative?.id) {
    context.case_id = narrative.id;
  }
  if (typeof message.id === 'number' && Number.isInteger(message.id)) {
    context.message_id = message.id;
  } else {
    const compositeId =
      message.composite_id ?? (message.id != null ? String(message.id) : '');
    if (compositeId) context.message_composite_id = compositeId;
  }
  return context;
}
